/**
 * Runtime config. Reads Vite env with proxy-friendly relative-path fallbacks so the
 * same build works in dev (vite proxy) and behind Apache in the flywheel container.
 */

export const COREBOS_API_URL =
  import.meta.env.VITE_COREBOS_API_URL || "/api";

export const KERNEL_API_URL =
  import.meta.env.VITE_KERNEL_API_URL || "/kernel/api/v1";

export const KERNEL_API_KEY = import.meta.env.VITE_KERNEL_API_KEY || "";
